/**
 * QMP-FE-4 — STEP 5 "AI Usage": one subarea, `ai` (D11.7), per package.
 *
 * LAYOUT AND COPY ARE THE MOCKUP'S (`mockup-qmp-v79-official.html`, `#w5`,
 * `rt("5", ...)`): no subnav (one subarea, v79 `renderSubnav`), the first row
 * "All packages" / "All other packages" and the packages with a rule of their
 * own. The standard — "Not allowed" — is the server's (`standard_rules.ai`).
 * The human invariants are a constant of the server, never a field.
 */
import React from 'react';
import {
  SubCard, LoadError, useTip, ValueSelect, CONTROL_ENDT,
} from './ItpRulesStep';
import { fieldOptions, formatAi } from '../../lib/qmpRules';

// QMP-FE-7 — the title is the server's (`editor.titles`).
export const SUBS5 = ['ai'];

const TIPS5 = {
  ai: {
    title: 'AI-assisted drafting',
    body: (
      <>
        AI can help prepare draft content, such as an ITP draft. <b>It cannot sign, endorse,
        approve or make quality decisions.</b> Those responsibilities always remain with a person.
      </>
    ),
  },
};

// `gsel(["Not allowed","Allowed"], q, "ai", i)` — the served choices of
// `allowed`, the field the whole rule is.
function AiCell({
  value, onChange, disabled, k, options,
}) {
  const served = fieldOptions(options, 'ai', 'allowed')
    .map((o) => ({ label: o.label, value: { allowed: o.value } }));
  return (
    <ValueSelect
      served={served}
      current={value}
      fallback={formatAi}
      disabled={disabled}
      className={CONTROL_ENDT}
      onPick={(v) => onChange(v)}
      testId={`qr-ai-${k}`}
    />
  );
}

const SECTION5 = {
  look: 'endt',
  title: 'Is AI-assisted drafting allowed?',
  help: 'Choose whether AI-assisted drafting is allowed in each package.',
  helpTip: 'ai',
  columns: [{ key: 'ai', label: 'AI-assisted drafting', width: '40%' }],
  cells: [AiCell],
  how: (
    <>
      Some projects allow AI-assisted drafting and others restrict it. Choose the rule that
      applies to each package.
    </>
  ),
};

export default function AiUsageStep({ editor }) {
  const { open, pop } = useTip(TIPS5);
  return (
    <div
      className="bg-[#0d1526] border border-[#16223a] rounded-[12px] px-[26px] py-[24px] min-w-0"
      data-testid="qs-pane-5"
    >
      <LoadError editor={editor} />
      <SubCard section="ai" conf={SECTION5} editor={editor} openTip={open} />
      {pop}
    </div>
  );
}
